const metaData = {
  fields: [
    'id',
    'active',
    'created_by',
    'created_at',
    'description',
    'sections',
    'name',
    'product_id',
    'is_completed',
    { product: ['total_marks', 'total_questions', 'name', 'id', 'type'] },
    'status',
    'test_track_id',
    { paper_requests: ['id'] },
    { papers: ['id'] },
    { test_tracks: ['id', 'name'] },
  ],
}

export default metaData
